<template>
  <div class="input">
    <input
      v-if="mask"
      :key="id"
      :id="id"
      :type="type"
      class="input__field"
      :class="classes"
      :placeholder="placeholder"
      :value="value"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      @input="updateModel"
      v-mask="mask"
    >

    <input
      v-else
      :key="id"
      :id="id"
      :type="type"
      class="input__field"
      :class="classes"
      :placeholder="placeholder"
      :value="value"
      :required="required"
      :readonly="readonly"
      :disabled="disabled"
      @input="updateModel"
    >
  </div>
</template>

<script>
export default {
  name: 'BaseInputText',

  props: {
    value: String,
    required: Boolean,
    readonly: Boolean,
    disabled: Boolean,
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: ''
    },
    variation: {
      type: String,
      default: ''
    },
    mask: String
  },

  computed: {
    classes () {
      return {
        'input__field--rounded': this.variation === 'rounded'
      }
    }
  },

  methods: {
    updateModel (event) {
      this.$emit('input', event.target.value)
    },

    generateInputKey () {
      const index = random(10000, 99999)

      return `input${index}`
    }
  }
}
</script>

<style lang="scss" scoped>
.input {
  &__field {
    @extend %input-text;

    &--rounded {
      border-radius: 2em;
    }
  }
}
</style>
